import React, { useMemo, useState } from 'react';
import { Copy, Eye, FileCode2 } from 'lucide-react';
import { useToast } from '../context/ToastContext';

const defaultOrigin = window.location.origin;

const EmbeddedForms = () => {
  const [form, setForm] = useState({
    title: 'Get a Quote',
    subtitle: 'Tell us what you need and our team will contact you.',
    source: 'main website',
    theme: 'dark',
    key: 'tbd_leads_2026_7a91c44f3d824bd8',
    height: 680,
  });
  const { showToast } = useToast();
  const set = (key, value) => setForm(current => ({ ...current, [key]: value }));

  const formUrl = useMemo(() => {
    const params = new URLSearchParams({
      key: form.key,
      source: form.source,
      title: form.title,
      subtitle: form.subtitle,
      theme: form.theme,
    });
    return `${defaultOrigin}/forms/lead?${params.toString()}`;
  }, [form]);

  const iframeCode = `<iframe src="${formUrl}" width="100%" height="${form.height}" style="border:0;border-radius:12px;overflow:hidden;" loading="lazy"></iframe>`;
  const htmlCode = `<div id="theblackdiv-lead-form"></div>
<script>
  (function () {
    var iframe = document.createElement('iframe');
    iframe.src = '${formUrl}';
    iframe.width = '100%';
    iframe.height = '${form.height}';
    iframe.loading = 'lazy';
    iframe.style.border = '0';
    iframe.style.borderRadius = '12px';
    iframe.style.overflow = 'hidden';
    document.getElementById('theblackdiv-lead-form').appendChild(iframe);
  })();
</script>`;

  const copy = async (text, label) => {
    await navigator.clipboard.writeText(text);
    showToast(`${label} copied`, 'success');
  };

  return (
    <div className="page-content">
      <div className="flex-between mb-24">
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Embedded Forms</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>Generate lead forms for any website and collect submissions in Leads.</p>
        </div>
        <button className="btn btn-secondary" onClick={() => window.open(formUrl, '_blank', 'noopener,noreferrer')}>
          <Eye size={16} /> Open Form
        </button>
      </div>

      <div className="grid-2">
        <div className="card">
          <h2 style={{ fontSize: 16, marginBottom: 16 }}>Form Settings</h2>
          <div className="input-group"><label className="input-label">Title</label><input className="input" value={form.title} onChange={e => set('title', e.target.value)} /></div>
          <div className="input-group"><label className="input-label">Subtitle</label><input className="input" value={form.subtitle} onChange={e => set('subtitle', e.target.value)} /></div>
          <div className="grid-2">
            <div className="input-group"><label className="input-label">Source</label><input className="input" value={form.source} onChange={e => set('source', e.target.value)} /></div>
            <div className="input-group"><label className="input-label">Theme</label><select className="input select" value={form.theme} onChange={e => set('theme', e.target.value)}><option value="dark">Dark</option><option value="light">Light</option></select></div>
          </div>
          <div className="grid-2">
            <div className="input-group"><label className="input-label">Lead API Key</label><input className="input" value={form.key} onChange={e => set('key', e.target.value)} /></div>
            <div className="input-group"><label className="input-label">Iframe Height</label><input className="input" type="number" min="520" value={form.height} onChange={e => set('height', e.target.value)} /></div>
          </div>
          <div className="input-group" style={{ marginBottom: 0 }}><label className="input-label">Public Form URL</label><input className="input" readOnly value={formUrl} /></div>
        </div>

        <div className="card">
          <h2 style={{ fontSize: 16, marginBottom: 16 }}>Preview</h2>
          <iframe title="Lead form preview" src={formUrl} style={{ width: '100%', height: 620, border: '1px solid var(--border)', borderRadius: 8 }} />
        </div>
      </div>

      <div className="grid-2 mt-24">
        <div className="card">
          <div className="flex-between mb-16">
            <h2 style={{ fontSize: 16 }}>Iframe Code</h2>
            <button className="btn btn-primary btn-sm" onClick={() => copy(iframeCode, 'Iframe code')}><Copy size={14} /> Copy</button>
          </div>
          <pre className="code-block"><code>{iframeCode}</code></pre>
        </div>
        <div className="card">
          <div className="flex-between mb-16">
            <h2 style={{ fontSize: 16 }}>HTML Embed Code</h2>
            <button className="btn btn-primary btn-sm" onClick={() => copy(htmlCode, 'HTML embed code')}><FileCode2 size={14} /> Copy</button>
          </div>
          <pre className="code-block"><code>{htmlCode}</code></pre>
        </div>
      </div>
    </div>
  );
};

export default EmbeddedForms;
